/**
 * Talking to somebody.
 *
 * What they said, and what can be said back. The answers are the server's to
 * decide, since what somebody is allowed to say depends on what they have done,
 * what they are carrying and how good they are, and none of that is the client's
 * business to rule on.
 *
 * Sits at the bottom of the screen where the eye already is after a click on
 * somebody, rather than in the middle of the world it is about.
 */

import type { DialoguePacket } from '@inverse/protocol';

export function Dialogue({
  packet,
  onChoose,
  onClose,
}: {
  packet: DialoguePacket;
  onChoose: (option: number) => void;
  onClose: () => void;
}): JSX.Element {
  return (
    <div className="dialogue">
      <div className="dialogue-head">
        <strong>{packet.name}</strong>
        <button type="button" className="dialogue-close" title="Leave it there" onClick={onClose}>
          ✕
        </button>
      </div>

      {/* A directory says nothing and offers a list of things to ask about, so
          there is no line above it to leave a gap where one would be. */}
      {packet.text.length > 0 ? <p className="dialogue-text">{packet.text}</p> : null}

      <div className="dialogue-options">
        {packet.options.map((option, index) => (
          <button
            key={`${index}-${option.text}`}
            type="button"
            className={option.barred ? 'dialogue-option barred' : 'dialogue-option'}
            disabled={option.barred}
            title={option.barred ? 'Not yet' : undefined}
            onClick={() => onChoose(index)}
          >
            <span className="dialogue-number">{index + 1}</span>
            {option.text}
          </button>
        ))}

        {packet.options.length === 0 ? (
          <button type="button" className="dialogue-option" onClick={onClose}>
            <span className="dialogue-number">1</span>
            Leave it there
          </button>
        ) : null}
      </div>
    </div>
  );
}
